import styled from 'styled-components';

export const Title = styled.div`
  display: flex;
  gap: 8px;
`;

export const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 20px;
  display: flex;
  flex-direction: column;

  .ant-divider-horizontal {
    margin: 0;
  }

  .content-divider {
    height: 8px;
    margin-left: -20px;
    width: calc(100% + 40px);
    background: #ededed;
    border: none;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 20px;
`;

export const InfoTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  h1,
  h6 {
    margin: 0;
    color: #333333;
  }

  h1 {
    font-size: 14px;
    line-height: 19px;
  }

  h6 {
    font-size: 20px;
    line-height: 27px;
  }
`;

export const BalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BalanceItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 4px;

  p {
    margin: 0;
    font-size: 14px;
    line-height: 19px;
    color: #333333;
  }

  p.negative {
    color: #ee4a49;
  }

  &.bold {
    font-weight: bold;
  }
`;

export const BalanceSettlementContainer = styled.div`
  display: flex;
  gap: 6px;
  border: 1px solid #ededed;
  border-radius: 4px;
  padding: 12px;
`;

export const BalanceSettlementItem = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  p {
    margin: 0;
    color: #333333;
  }

  p.bold {
    font-weight: bold;
  }

  p.date {
    color: #858585;
    margin-bottom: 6px;
  }
`;

export const LegendsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 20px;

  p {
    margin: 0;
    color: #333333;
    font-size: 14px;
    line-height: 19px;
  }
`;
